import { createSlice } from '@reduxjs/toolkit';

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    data: {
      isInitialized: false,
      theme: null,
    },
  },
  reducers: {
    setTheme: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setTheme } = themeSlice.actions;

export const selectTheme = (state: any) => state.theme.data;

export default themeSlice.reducer;
